/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// Los cuatro bloques comparten definiciones con la misma clave, así el servicio UART y
// el diccionario de mensajes se declaran una sola vez por programa.

const BLUETOOTH_SETUP = `
bluetooth.onBluetoothConnected(function () {
  music.play(music.stringPlayable("G A C5 - - - - - ", 220), music.PlaybackMode.UntilDone)
})
bluetooth.startUartService()
`;

// La app manda tramas "<letra><valor>", así que los mensajes se guardan en un
// diccionario indexado por la etiqueta.
const MESSAGE_SETUP = `
interface Message {
  [key: string]: string;
}
let mensajeBt: Message = {}
`;

const READ_HELPERS = `
function leerTexto(etiqueta: string) {
  if (mensajeBt[etiqueta] !== undefined) {
    return mensajeBt[etiqueta]
  } else {
    return ""
  }
}
function leerNumero(etiqueta: string) {
  if (mensajeBt[etiqueta] !== undefined) {
    return parseFloat(mensajeBt[etiqueta])
  } else {
    return 0
  }
}
`;

export const microbit_bluetooth_read = (block, generator) => {
  const isNumber = block.getFieldValue('ICON') === 'number';
  const label = block.getFieldValue('LABEL');

  generator.definitions_['bluetooth_read'] = READ_HELPERS;
  generator.definitions_['bluetooth'] = BLUETOOTH_SETUP;
  generator.definitions_['bluetooth_message_definition'] = MESSAGE_SETUP;

  return [`${isNumber ? 'leerNumero' : 'leerTexto'}("${label}")`, generator.ORDER_ATOMIC];
};

export const microbit_bluetooth_send = (block, generator) => {
  const label = block.getFieldValue('LABEL');
  // Saca la comilla simple para desarmar el doble encomillado del generador de `text`
  // ("'hola'" -> "hola").
  const text = (generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  generator.definitions_['bluetooth'] = BLUETOOTH_SETUP;

  return `bluetooth.uartWriteString("${label}" + ${text})\n`;
};

// Las tramas que empiezan con JOY las maneja microbit_bluetooth_control; acá se descartan.
export const microbit_bluetooth_if = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  generator.definitions_['bluetooth'] = BLUETOOTH_SETUP;
  generator.definitions_['bluetooth_message_definition'] = MESSAGE_SETUP;

  const code = `bluetooth.onUartDataReceived(serial.delimiters(Delimiters.NewLine), function () {
  const mensaje = bluetooth.uartReadUntil(serial.delimiters(Delimiters.NewLine))
  if (!mensaje.includes("JOY")) {
    const letra = mensaje.charAt(0)
    const valor = mensaje.substr(1, mensaje.length)
    mensajeBt[letra] = valor
  }
  ${branch}
})
`;

  if (typeof block !== 'undefined' && block.id) {
    generator.setups_[block.id] = code;
  }

  return '';
};

// La app manda "JOY" + una letra por dirección: U/D/R/L arriba, abajo, derecha,
// izquierda; S el centro (frenar); A y B los botones.
const JOYSTICK_BRANCHES = [
  ['U', 'STACK_UP'],
  ['D', 'STACK_DOWN'],
  ['R', 'STACK_RIGHT'],
  ['L', 'STACK_LEFT'],
  ['S', 'STACK_CENTER'],
  ['A', 'STACK_A'],
  ['B', 'STACK_B'],
];

export const microbit_bluetooth_control = (block, generator) => {
  generator.definitions_['bluetooth'] = BLUETOOTH_SETUP;

  const branches = JOYSTICK_BRANCHES
    .map(([letter, input], i) => {
      const branch = generator.statementToCode(block, input).replace(/&quot;/g, '"');
      const keyword = i === 0 ? 'if' : '} else if';

      return `    ${keyword} (texto.substr(3, 1) == "${letter}") {\n      ${branch}\n`;
    })
    .join('');

  const code = `bluetooth.onUartDataReceived(serial.delimiters(Delimiters.NewLine), function () {
  const texto = bluetooth.uartReadUntil(serial.delimiters(Delimiters.NewLine))
  if (texto.includes("JOY")) {
${branches}    }
  }
})
`;

  if (typeof block !== 'undefined' && block.id) {
    generator.setups_[block.id] = code;
  }

  return '';
};
